<template>
  <div class="table-parent">
    <ProgressView v-if="loadingData" :top="50" />

    <simplebar
      class="table-scroll-wrapper"
      data-simplebar-auto-hide="false"
      ref="scroll"
    >
      <div class="table" :class="`grid-template-columns-${headers.length}`">
        <div
          :class="['cell', 'firstRow', { firstCell: index === 0 }]"
          v-for="(heading, index) in headers"
          :key="heading.text + index"
          @click="handleSortChange(heading)"
        >
          <!-- @click="$emit('onSortChange', heading)" -->
          <div class="flex-center">
            <!-- Checkbox Icons: -->
            <!-- <icon
          v-if="
            index === 0 && selectedRows.length !== filteredAndSortedRows.length
          "
          class="checkbox"
          size="18"
          @click="selectAllRows(heading.text)"
          >check_box_outline_blank</icon
        >
        <icon
          v-else-if="
            index === 0 && selectedRows.length === filteredAndSortedRows.length
          "
          class="checkbox"
          size="18"
          @click="unselectAllRows"
          >check_box</icon
        > -->
            <span>{{ heading.text || "-" }}</span>
          </div>
          <div class="flex-center">
            <!-- Filter Icons: -->
            <icon
              v-if="showFilters && heading.filters"
              class="filterIcon"
              size="18"
              @click="
                showFilterFor =
                  showFilterFor === heading.text ? null : heading.text
              "
              >filter_list</icon
            >
            <SlideYUpTransition>
              <div
                v-if="showFilters && showFilterFor === heading.text"
                class="filterDropdown"
                v-click-outside="
                  () => {
                    showFilterFor = null;
                  }
                "
              >
                <simplebar
                  class="list-wrapper"
                  data-auto-hide="false"
                  scrollbarMaxSize="30"
                >
                  <div
                    v-for="filter in heading.filters"
                    :key="filter.id"
                    @click.stop="selectItem($event, filter, heading)"
                    class="option flex-row-align-center"
                  >
                    <p class="ellipsis">{{ filter.name }}</p>
                    <icon v-if="filter.isActive" size="18">check</icon>
                  </div>
                </simplebar>
              </div>
            </SlideYUpTransition>

            <!-- Sort Icons: -->
            <icon
              v-if="sort.columnId !== heading.id"
              size="18"
              @click="handleSortChange(heading)"
              >unfold_more</icon
            >
            <!-- @click="$emit('onSortChange', heading)" -->
            <icon
              v-else-if="sort.columnId === heading.id && sort.asc"
              size="18"
              @click="handleSortChange(heading)"
              >keyboard_arrow_down</icon
            >
            <!-- @click="$emit('onSortChange', heading)" -->
            <icon v-else size="18" @click="handleSortChange(heading)"
              >keyboard_arrow_up</icon
            >
            <!-- @click="$emit('onSortChange', heading)" -->
          </div>
        </div>

        <template v-for="(row, rowNumber) in sortedRows">
          <template v-for="(header, index) in headers">
            <div
              :class="[
                'cell',
                { firstCol: index === 0 },
                { alternateRow: rowNumber % 2 },
              ]"
              :key="rowNumber + '_' + index"
            >
              <!-- :key="header.text + '_' + rowNumber + '_' + row[header.text]" -->
              <!-- Checkbox Icons: -->
              <!-- <icon
            v-if="index === 0 && !selectedRows.includes(row[header.text])"
            class="checkbox"
            size="18"
            @click="selectRow(row[header.text])"
            >check_box_outline_blank</icon
          >
          <icon
            v-else-if="index === 0 && selectedRows.includes(row[header.text])"
            class="checkbox"
            size="18"
            @click="unselectRow(row[header.text])"
            >check_box</icon
          > -->
              <span>{{
                header.format ? formatNumber(row[header.id], 3) : row[header.id]
              }}</span>
              <!-- -->
            </div>
          </template>
        </template>
      </div>

      <div v-if="sortedRows && sortedRows.length <= 0" class="no-data">
        <img src="@/assets/not_found.svg" />
        <p>No data found.</p>
      </div>
    </simplebar>
  </div>
</template>

<script>
import { SlideYUpTransition } from "vue2-transitions";
import { format } from "@/lib/numberFormatter";

export default {
  components: {
    SlideYUpTransition,
  },
  props: {
    headers: Array,
    rows: Array,
    showFilters: Boolean,
    offsetForTrigger: {
      type: Number,
      default: 450,
    },
    loadingData: Boolean,
  },
  data() {
    return {
      selectedRows: [],
      showFilterFor: null,
      sort: {},
    };
  },
  computed: {
    hasSortChangeListener() {
      return this.$listeners && this.$listeners.onSortChange;
    },
    hasLoadMoreListener() {
      return this.$listeners && this.$listeners.onLoadMore;
    },
    // filteredRows() {
    //   // TODO: To be moved if every change is coming from API
    //   return [...this.rows];
    // },
    sortedRows() {
      if (!this.hasSortChangeListener) {
        // Sort locally if there is no onSortChange listener on the component:
        return [...this.rows].sort((row1, row2) => {
          // Sorting for numbers:
          if (
            typeof row1[this.sort.columnId] === "number" &&
            typeof row2[this.sort.columnId] === "number"
          ) {
            // console.log("number: ", row1[this.sort.columnId]);
            return this.sort.asc
              ? row1[this.sort.columnId] - row2[this.sort.columnId]
              : row2[this.sort.columnId] - row1[this.sort.columnId];
          }

          // Sorting for objects of data and formattedData:
          // if (
          //   typeof row1[this.sort.columnId] === "object" &&
          //   typeof row2[this.sort.columnId] === "object"
          // ) {
          //   console.log("object: ", row1[this.sort.columnId]);
          //   return this.sort.asc
          //     ? row1[this.sort.columnId].data -
          //         row2[this.sort.columnId].data
          //     : row2[this.sort.columnId].data -
          //         row1[this.sort.columnId].data;
          // }

          // Sorting for strings:
          // console.log("string: ", row1[this.sort.columnId]);
          let item1 = (row1[this.sort.columnId] || "-")
            .toString()
            .toUpperCase();
          let item2 = (row2[this.sort.columnId] || "-")
            .toString()
            .toUpperCase();
          if (item1 < item2) {
            return this.sort.asc ? -1 : 1;
          }
          if (item1 > item2) {
            return this.sort.asc ? 1 : -1;
          }
          return 0;
        });
      }

      return this.rows;
    },
  },
  methods: {
    selectRow(firstColValue) {
      this.selectedRows.push(firstColValue);
    },
    unselectRow(firstColValue) {
      this.selectedRows.splice(this.selectedRows.indexOf(firstColValue), 1);
    },
    selectAllRows(firstColName) {
      this.selectedRows = this.rows.map((row) => row[firstColName]);
    },
    unselectAllRows() {
      this.selectedRows = [];
    },
    formatNumber(num, precision) {
      let value = parseFloat(num || 0);
      value = isNaN(value) ? 0 : value;
      // value = format(value.toFixed(0), precision);
      value = +value.toFixed(precision);
      // value = Math.ceil(value);
      return value;
    },
    selectItem($event, filter, heading) {
      $event.stopPropagation();
      this.$emit("onFilterChange", { filter, heading });
      this.showFilterFor = null;
    },
    handleSortChange(heading) {
      this.$refs.scroll.scrollElement.scrollTop = 0;
      // For tracking sorting type:
      this.sort = {
        columnId: heading.id,
        columnName: heading.text,
        asc: this.sort.columnId === heading.id ? !this.sort.asc : true,
      };

      if (this.hasSortChangeListener) {
        // If onSortChange listener is present on the component, emit an event:
        // console.log("Call external Function");
        this.$emit("onSortChange", this.sort);
      } else {
        // console.log("Just let computed property recalculated automatically");
      }
    },
    handleScroll(event) {
      let { scrollTop, scrollHeight, clientHeight } = event.target;

      if (scrollHeight - clientHeight - this.offsetForTrigger < scrollTop) {
        if (!this.isEventsLoading) this.$emit("onLoadMore");
      }
    },
  },
  watch: {
    // selectedRows(rows) {
    // console.log({ rows });
    // },
    // headers(headers) {
    // console.log({ headers });
    // },
  },
  mounted() {
    if (this.hasLoadMoreListener) {
      // console.log("hasLoadMoreListener setting listener");
      this.$refs.scroll.scrollElement.addEventListener(
        "scroll",
        this.handleScroll
      );
    }
  },
};
</script>

<style lang="scss" scoped>
@for $i from 1 to 51 {
  .grid-template-columns-#{$i} {
    grid-template-columns: repeat($i, 1fr);
  }
}

.table-parent {
  background: var(--color-default-background);
  height: 100%;
  position: relative;
}
.table-scroll-wrapper {
  height: 100%;
}

.no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 50px 0;
  img {
    width: 300px;
    height: auto;
  }
  p {
    margin-bottom: 0;
  }
}

.table {
  /* background: var(--color-secondary-light); */
  /* grid-template-rows: auto; */
  display: grid;

  .cell {
    padding: 10px 15px;
    min-width: 160px;
    display: flex;
    align-items: center;
    /* &:hover {
      background: var(--color-secondary-light);
    } */

    i {
      padding: 5px;
      /* margin-left: 5px; */
      border-radius: 50%;
      transition: 0.3s all ease-in-out;

      /* margin-right: 5px; */

      &:hover {
        background: var(--color-secondary-light);
        cursor: pointer;
      }

      &:active {
        transform: scale(0.9);
      }

      &.active {
        background: var(--color-primary-light);
        color: var(--color-primary);
      }
    }
  }

  .filterIcon {
    margin-right: 5px;
  }

  .filterDropdown {
    position: absolute;
    top: 100%;
    left: 0;
    background: var(--color-secondary);
    width: 100%;
    margin-top: 5px;
    border-radius: 5px;
    box-sizing: border-box;
    overflow: auto;
    max-height: 300px;

    .list-wrapper {
      overflow: auto;
      max-height: 250px;
    }
    .option {
      padding: 10px 15px;
      border-bottom: 1px solid var(--border-color);
      display: flex;
      flex-direction: row;
      align-items: center;

      &:last-child {
        border: 0;
      }

      &:hover {
        background-color: var(--color-secondary-light);
        cursor: pointer;
      }

      i {
        pointer-events: none;
      }

      p {
        margin: 0;
        flex: 1;
      }
    }
  }

  .checkbox {
    margin-right: 15px;
    cursor: pointer;
  }

  .firstCell {
    position: sticky;
    top: 0px;
    left: 0px;
    z-index: 3;
    border-right: solid 1px var(--border-color);
  }

  .firstRow {
    font-weight: bold;
    /* background: var(--color-secondary-light); */
    background: var(--color-secondary);
    position: sticky;
    top: 0;
    border-bottom: solid 1px var(--border-color);
    border-top: solid 1px var(--border-color);
    border-right: solid 1px var(--border-color);
    transition: 0.3s all ease-in-out;
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:hover {
      cursor: pointer;
      /* background: var(--color-primary-light); */
    }

    &:last-child {
      border-right: none;
    }
  }

  .firstCol {
    position: sticky;
    left: 0;
    background: var(--color-default-background);
    /* border-right: solid 1px var(--border-color); */
    /* background: var(--color-secondary); */
    z-index: 2;

    display: flex;
    align-items: center;
  }

  .alternateRow {
    background: var(--color-secondary-light);

    &.firstCol {
      /* background: var(--color-secondary); */
    }
  }
}
</style>
